import packageInfo from "../../../package.json";
import { fetchRetry } from "../../utils/retry";

/**
 * The User-Agent is required by the AWS WAF
 * The X-Application is required by Security Team
 * https://github.com/module-federation/universe/tree/main/packages/node#overrideing-default-http-chunk-fetch
 */
export const fetchRemoteComponent = async (
  url: string,
  options: RequestInit = {},
) =>
  await fetchRetry(() =>
    fetch(url, {
      ...options,
      headers: {
        ...(options.headers ? options.headers : {}),
        "User-Agent": `unified-shell/${packageInfo.version}`,
        "X-Application": `unified-shell/${packageInfo.version}`,
      },
      /**
       * It's preferable to set a relatively short timeout for requests to ensure a smooth user experience.
       * This helps prevent the application from becoming unresponsive due to slow or unreachable remote.
       * In case of a timeout, falling back to client-side rendering ensures that users can interact with the application.
       */
      signal: AbortSignal.timeout(1500),
    }),
  );
